export enum MediaServiceAccessTypeEnum {
    PUBLIC = 'public',
    PRIVATE = 'private'
}
